import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AccessType } from "./AccessType";
import type { ScopesRef } from "./ScopesRef";
import type { ScopesStaff } from "./ScopesStaff";
import type { UserPermissionDTOBase } from "./UserPermissionDTOBase";
import type { UserStaff } from "./UserStaff";

export class UserPermissionStaff implements UserPermissionDTOBase {
  constructor(public readonly userPermissionId: number, public readonly userId: UserStaff | null, public readonly scopeId: ScopesStaff | null, public readonly accessType: AccessType, public readonly assignedBy: UserStaff | null, public readonly assignedOn: Date, public readonly scopeIdTargetIds: ScopesRef) {
    this.cbiServiceContext = null;
    this.userIdLoaded = this.userId != null;
    this.userIdCached = this.userId;
    this.scopeIdLoaded = this.scopeId != null;
    this.scopeIdCached = this.scopeId;
    this.assignedByLoaded = this.assignedBy != null;
    this.assignedByCached = this.assignedBy;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private userIdLoaded: boolean;
  private userIdCached: UserStaff | null;
  private scopeIdLoaded: boolean;
  private scopeIdCached: ScopesStaff | null;
  private assignedByLoaded: boolean;
  private assignedByCached: UserStaff | null;
  async userIdLazy(): Promise<UserStaff> {
    if (!this.userIdLoaded) {
      this.userIdCached = await this.cbiServiceContext!.permissionService().getUserPermissionStaffUserId(this.userPermissionId);
      this.userIdLoaded = true;
    }
    return this.userIdCached!;
  }
  async scopeIdLazy(): Promise<ScopesStaff> {
    if (!this.scopeIdLoaded) {
      this.scopeIdCached = await this.cbiServiceContext!.permissionService().getScopesStaff(this.scopeIdTargetIds.scopeId);
      this.scopeIdLoaded = true;
    }
    return this.scopeIdCached!;
  }
  async assignedByLazy(): Promise<UserStaff> {
    if (!this.assignedByLoaded) {
      this.assignedByCached = await this.cbiServiceContext!.permissionService().getUserPermissionStaffAssignedBy(this.userPermissionId);
      this.assignedByLoaded = true;
    }
    return this.assignedByCached!;
  }
}
